import './App.css';
import Register from './components/Register';
import logo from "./assets/logo.png";
import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Login from './components/Login';
import RegisterUser from './components/RegisterUser';
import CreateObject from './components/CreateObject';
import Dashboard from './components/Dashboard';
import ObjectList from './components/ObjectList';
import Price from './components/Price';
import Availability from './components/Availability';
import Impressum from './components/Impressum';
import ProtectedRoute from './components/ProtectedRoute';
import TopBar from './components/TopBar';
import Footer from "./components/Footer";

// AutoLogout
import useAutoLogout from './hooks/useAutoLogout';
import { performClientLogout } from './utils/authUtils';

function AutoLogoutWrapper({ children }) {
  const navigate = useNavigate();

  useAutoLogout({
    timeout: 10 * 60 * 1000,
    onLogout: () => performClientLogout(navigate),
  });

  return children;
}

function App() {

  console.log("APP URL:", window.location.href);

  const location = useLocation();
  const hideMenuRoutes = ["/login", "/register", "/register-user"];
  const shouldHideMenu = hideMenuRoutes.includes(location.pathname);

  return (
    <div className="App">
      <div className="tree-background" />

      {/* Logo nur anzeigen, wenn die TopBar versteckt ist */}
      {shouldHideMenu && (
        <header className="main-header">
          <div className="header-left">
            <img src={logo} alt="Logo" className="app-logo" />
          </div>
        </header>
      )}

      {/* TopBar nur anzeigen, wenn sie NICHT versteckt ist */}
      {!shouldHideMenu && <TopBar />}




      <main className="main-content">
        <Routes>

          {/* Öffentliche Routen */}
          <Route path="/register" element={<Register />} />
          <Route path="/create-object" element={<CreateObject />} />
          <Route path="/login" element={<Login />} />
          <Route path="/impressum" element={<Impressum />} />

          {/* Register-User: geschützt, aber OHNE AutoLogout */}
          <Route
            path="/register-user"
            element={
              <ProtectedRoute allowIncompleteProfile={true}>
                <RegisterUser />
              </ProtectedRoute>
            }
          />

          {/* Geschützte Routen MIT AutoLogout */}
          <Route
            path="/dashboard"
            element={
              <AutoLogoutWrapper>
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              </AutoLogoutWrapper>
            }
          />

          <Route
            path="/object-list"
            element={
              <AutoLogoutWrapper>
                <ProtectedRoute>
                  <ObjectList />
                </ProtectedRoute>
              </AutoLogoutWrapper>
            }
          />

          <Route
            path="/prices/:objectId"
            element={
              <AutoLogoutWrapper>
                <ProtectedRoute>
                  <Price />
                </ProtectedRoute>
              </AutoLogoutWrapper>
            }
          />

          <Route
            path="/availability/:objectId"
            element={
              <AutoLogoutWrapper>
                <ProtectedRoute>
                  <Availability />
                </ProtectedRoute>
              </AutoLogoutWrapper>
            }
          />

          {/* Default */}
          <Route
            path="/"
            element={
              <AutoLogoutWrapper>
                <ProtectedRoute>
                  <ObjectList />
                </ProtectedRoute>
              </AutoLogoutWrapper>
            }
          />

        </Routes>
      </main>
      {!shouldHideMenu && <Footer />}
    </div>
  );
}

export default function Root() {
  return (
    <Router>
      <App />
    </Router>
  );
}